module.exports = __webpack_public_path__ + "static/media/zoleLogo.84d3d86c.svg";